/** Manufacturer-based winter tyre navigation tiers. */

const WinterTyreTiers = {

    premium: [
        "bridgestone", "continental", "dunlop", "goodyear", "hankook", "michelin", "nokian", "pirelli", "yokohama"
    ],

    quality: [
        "apollo", "barum", "bf goodrich", "ceat", "cooper", "debica", "falken", "firestone", "fulda", "general tire", "gislaved", "giti", "gt radial", "kleber", "kormoran", "kumho", "lassa", "laufenn", "marshal", "matador", "maxxis", "nexen", "nordman", "petlas", "radar", "roadstone", "sava", "semperit", "toyo", "uniroyal", "vredestein"
    ],

    budget: [
        "atlas", "arivo", "comforser", "dayton", "delinte", "dynamo", "fortuna", "fortune", "goodride", "gripmax", "haida", "hifly", "imperial", "landsail", "leao", "linglong", "minerva", "nankang", "ovation", "rotalla", "rovelo", "sailun", "sunny", "superia", "taurus", "tourador", "tracmax", "trazano", "triangle", "tristar", "westlake", "windforce", "winrun", "zmax"
    ]

};

export default WinterTyreTiers;
